import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import EditableTable from '../../../../primer/Editable-Table';
import {deleteObjectFromArrayOfObjects} from '../../../../../_helpers/helperFunctions';
import {
    getDOYOptions,
    getInstallationsTypes, getVatCategoryAbroadOptions, getVatCategoryOptions
} from '../../../../../_helpers/commonFunctions';
import {
    resetNewInstallations,
    setEditClient,
    setNewInstallations
} from '../../../../../_reducers/DataPanel/Clients/clientSlice';
import {setSaveEditClient} from '../../../../../_reducers/activitySlice';
import getMyData from "../../../../../_helpers/sharedmydata";
import {toast} from "react-toastify";
import useTaggedDispatch from "../../../../../hooks/useTaggedDispatch";
import {useTranslation} from "../../../../../hooks/useTranslation";

const EditClientInstallations = ({tabKey}) => {
    const {t, locale} = useTranslation();
    const dispatch = useTaggedDispatch({tabKey});
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
    const editClient = useSelector((state) => state.CLIENTS_DATA.editClient[tabKey]);
    const vatCategoryInstallationList = editClient.categoryName === "Client within E.U." || editClient.categoryName === "Client outside E.U." ? getVatCategoryAbroadOptions() : getVatCategoryOptions();
    const doyList = editClient.categoryName === "Client within E.U." || editClient.categoryName === "Client outside E.U." ? [] : getDOYOptions();
    const zeroVatReasonOptions = getMyData({type: 'zerovatreason'});
    const clientInstallationsColumns = [
        {
            name: "Αριθμός Εγκατάστασης",
            field: "no",
            width: "7%",
            editable: true,
            inputType: {
                type: 'number',
            }
        },
        {
            name: t('ClientsGeneralInstallations.table.type'),
            field: "type",
            editable: true,
            width: "15%",
            inputType: {
                options: getInstallationsTypes(),
                type: 'dropdown',
                config: {
                    searchEnable: true
                }
            }
        },
        {
            name: t('ClientsGeneralInstallations.table.address'),
            field: "address",
            width: "15%",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralInstallations.table.installationDoy'),
            field: "DOY",
            editable: true,
            width: "15%",
            inputType: {
                options: doyList,
                type: 'dropdown',
                config: {
                    searchEnable: true
                }
            }
        },
        {
            name: t('ClientsGeneralInstallations.table.city'),
            field: "city",
            width: "15%",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralInstallations.table.postalCode'),
            field: "postalCode",
            width: "10%",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralInstallations.table.installationVatCategory'),
            field: "vatCategory",
            editable: true,
            width: "15%",
            inputType: {
                options: vatCategoryInstallationList,
                type: 'dropdown',
            }
        },
        {
            name: t('ClientsGeneralInstallations.table.0VatReason'),
            field: "vatReason",
            editable: true,
            width: "20%",
            disabled: true,
            inputType: {
                options: zeroVatReasonOptions,
                type: 'dropdown',
                config: {
                    searchEnable: true
                }
            }
        },
        {
            name: t('ClientsGeneralInstallations.table.customVat'),
            field: "customVat",
            editable: true,
            disabled: true,
            width: "10%",
            inputType: {
                type: 'number',
            }
        },
    ]
    useEffect(() => {
        setTableColumns(clientInstallationsColumns.slice());
    }, [locale])

    const [tableColumns, setTableColumns] = useState(clientInstallationsColumns.slice());
    const parentMydataActions = {
        insert: (e, data) => {
            let tempInstallations = Object.assign({}, CLIENTS_DATA.newInstallation);
            if (e.key !== "Enter") {
                tempInstallations[data.field] = data.value;
                dispatch(setNewInstallations(tempInstallations)); // Update redux
                let oldInstallations = editClient.installations;
                if (data.field === "no") {
                    const findDuplicate = oldInstallations.filter(installation => installation.no.toString() === data.value);
                    if (findDuplicate.length > 0) {
                        toast.error("Ο Αριθμός Εγκατάστασης υπάρχει ηδη.");
                        dispatch(resetNewInstallations());
                        return;
                    }
                }
                let updatedInstallation = Object.assign({}, tempInstallations);
                if ((updatedInstallation && updatedInstallation.vatCategory === 'Zero VAT' && updatedInstallation.vatReason === '') || (updatedInstallation && updatedInstallation.vatCategory === 'Custom VAT' && updatedInstallation.customVat === '')) {
                    dispatch(setSaveEditClient(false));
                }
                if (updatedInstallation && (updatedInstallation.address !== '' && updatedInstallation.DOY !== '' && updatedInstallation.city !== '' && updatedInstallation.vatCategory !== '' && updatedInstallation.postalCode !== '' && updatedInstallation.no !== '')) {
                    updatedInstallation.id = oldInstallations.length;
                    dispatch(setEditClient({
                        ...editClient,
                        installations: [...oldInstallations, updatedInstallation]
                    }));
                    dispatch(resetNewInstallations()); // Reset
                    dispatch(setSaveEditClient(true));
                    toast.success('Please press Save in order to save the installation changes');
                } else if (updatedInstallation && (editClient.categoryName === "Client within E.U." || editClient.categoryName === "Client outside E.U.") && (updatedInstallation.address !== '' && updatedInstallation.no !== '' && updatedInstallation.postalCode !== '' && updatedInstallation.city !== '' && updatedInstallation.vatCategory !== '')) {
                    updatedInstallation.id = oldInstallations.length;
                    dispatch(setEditClient({
                        ...editClient,
                        installations: [...oldInstallations, updatedInstallation]
                    }));
                    dispatch(resetNewInstallations()); // Reset
                    dispatch(setSaveEditClient(true));
                    toast.success('Please press Save in order to save the installation changes');
                }
                console.log(tempInstallations)
            } else {
                let updatedInstallation = Object.assign({}, CLIENTS_DATA.newInstallation);
                let oldInstallations = editClient.installations;
                if (data.field === "no") {
                    const findDuplicate = oldInstallations.filter(installation => installation.no.toString() === data.value);
                    if (findDuplicate.length > 0) {
                        toast.error("Ο Αριθμός Εγκατάστασης υπάρχει ηδη.");
                        dispatch(resetNewInstallations());
                        return;
                    }
                }
                if (data.field === 'add' || e.key === 'Enter') {
                    if (updatedInstallation && (updatedInstallation.address !== '' && updatedInstallation.DOY !== '' && updatedInstallation.no !== '' && updatedInstallation.postalCode !== '' && updatedInstallation.city !== '' && updatedInstallation.vatCategory !== '')) {
                        updatedInstallation.id = oldInstallations.length;
                        dispatch(setEditClient({
                            ...editClient,
                            installations: [...oldInstallations, updatedInstallation]
                        }));
                        dispatch(resetNewInstallations()); // Reset
                        dispatch(setSaveEditClient(true));
                        toast.success('Please press Save in order to save the installation changes');
                    } else if (updatedInstallation && (editClient.categoryName === "Client within E.U." || editClient.categoryName === "Client outside E.U.") && (updatedInstallation.address !== '' && updatedInstallation.city !== '' && updatedInstallation.no !== '' && updatedInstallation.postalCode !== '' && updatedInstallation.vatCategory !== '')) {
                        updatedInstallation.id = oldInstallations.length;
                        dispatch(setEditClient({
                            ...editClient,
                            installations: [...oldInstallations, updatedInstallation]
                        }));
                        dispatch(resetNewInstallations()); // Reset
                        dispatch(setSaveEditClient(true));
                        toast.success('Please press Save in order to save the installation changes');
                    }
                }
            }
        },
        update: (data, id) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) {
                dispatch(setSaveEditClient(true));
            }
            let installations = editClient.installations.slice();
            if (data?.no) {
                const findDuplicate = installations.filter(installation => installation.no.toString() === data.no);
                if (findDuplicate.length > 0) {
                    toast.error("Ο Αριθμός Εγκατάστασης υπάρχει ηδη.");
                    dispatch(resetNewInstallations());
                    return;
                }
            }
            if (installations.find(item => item.id === id) !== undefined) {
                installations[id] = {...installations[id], ...data};
                dispatch(setEditClient({...editClient, installations: installations})); // update data
            }
        },
        selected: () => {
            console.log('selected mydata row clicked');
        },
        delete: (id) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) {
                dispatch(setSaveEditClient(true));
            }
            let installations = editClient.installations.slice();
            if (id !== '') {
                installations = deleteObjectFromArrayOfObjects(installations, id, 'no');
                dispatch(setEditClient({...editClient, installations: installations}))
            }
        }
    }


    return (
        <div className="new-client-general">
            <p className="text-muted"><i>{t('ClientsGeneralInstallations.installations')}</i></p>
            <EditableTable
                tableName="Client New Installations"
                key={Math.random()}
                allowActions={true}
                allowToggleColumns={false}
                columns={tableColumns}
                allowInsertRow={true}
                enableNewRowCheckbox={true}
                data={editClient.installations}
                onUpdate={parentMydataActions}
            />
        </div>
    )
}

export default EditClientInstallations;
